import React from 'react';
import Avatar from 'antd/lib/avatar';
import 'antd/lib/avatar/style/index.css';
import Table from 'antd/lib/table';
import 'antd/lib/table/style/index.css';
import 'antd/lib/pagination/style/index.css';
import ListUserEventRoleItemSelect from './ListUserEventRoleItemSelect';
import ListUserEventRoleItemIcon from './ListUserEventRoleItemIcon';
var ListUserEventRole = function (props) {
    var columns = [{
            title: 'Name',
            dataIndex: 'user.userProfile.name',
            key: 'name',
            render: function (name, uER) { return (React.createElement("div", null,
                React.createElement(Avatar, { shape: 'square', icon: 'user', src: (uER.user && uER.user.userProfile) ? uER.user.userProfile.avatar : undefined, style: { marginRight: '1.2rem' } }),
                React.createElement("span", { style: { marginRight: '.6rem' } }, name || '...'),
                React.createElement(ListUserEventRoleItemIcon, { userEventRole: uER }))); },
        }, {
            title: 'Role',
            dataIndex: 'role',
            key: 'role',
            render: function (role, uER) {
                return (React.createElement(ListUserEventRoleItemSelect, { userEventRole: uER, user: props.user, handlePatchUserEventRole: props.handlePatchUserEventRole }));
            },
        }];
    return (React.createElement(Table, { rowKey: 'id', columns: columns, dataSource: props.userEventRoles, locale: { emptyText: 'No users :(' }, pagination: { pageSize: 100 } }));
};
export default ListUserEventRole;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/ListUserEventRolePage/ListUserEventRole.tsx
// module id = 1043
// module chunks = 0